// extracted by mini-css-extract-plugin
export default {"charts":"Content_charts__zJUgO"};